import Proxy from './Proxy';

class MediaProxy extends Proxy {
  /**
   * The constructor for the ArtistProxy.
   *
   * @param {Object} parameters The query parameters.
   */
  constructor(parameters = {}) {
    super('api/media', parameters);
  }

  /**
   * 엑셀 업로드 완료
   * @param param
   * @returns {Promise}
   */
  uploadComplete(param) {
    return this.submit('post', `${this.endpoint}/excels/complete`, param);
  }

  /**
   * 광고 수정
   * @param item
   * @returns {Promise}
   */
  updateAdvertisement(item) {
    console.log(item);
    return this.submit('put', `/${this.endpoint}`, item);
  }

  /**
   * 이전 광고 조회
   * @param advertisementSeq
   * @returns {Promise}
   */
  findByIdPreAdvertisement(advertisementSeq) {
    return this.submit('get', `/${this.endpoint}/${advertisementSeq}/pre-advertisement`);
  }

  /**
   * 광고 삭제
   * @returns {Promise}
   */
  deleteByIds() {
    return this.submit('delete', `/${this.endpoint}`)
  }
}

export default MediaProxy;
